// core
import React from 'react';
import { useDispatch } from 'react-redux';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import Button from '@material-ui/core/Button';

// events
import { createBoard } from '../../../events';

// ui
import noBoardIcon from './noBoardIcon.png';
import styles from './styles.module.css';

// localization
const messages = defineMessages({
  NO_BOARD_SELECTED: {
    id: 'NO_BOARD_SELECTED',
    defaultMessage: 'You don\'t have any boards',
  },
  ADD_A_BOARD_TO_GET_STARTED: {
    id: 'ADD_A_BOARD_TO_GET_STARTED',
    defaultMessage: 'Add a board to get started.',
  },
  ADD_A_BOARD: {
    id: 'ADD_A_BOARD',
    defaultMessage: 'ADD A BOARD',
  },
  NEW_BOARD: {
    id: 'NEW_BOARD',
    defaultMessage: 'New Board',
  },
});

function NoBoard({ intl }) {
  const dispatch = useDispatch();

  return (
    <div style={{ display: 'flex' }}>
      <div className={styles.noBoard}>
        <div>
          <img src={noBoardIcon} alt="logo" className={styles.noIcons} />
          <p className={styles.noBoardMessage}>
            <FormattedMessage {...messages.NO_BOARD_SELECTED} />
          </p>
          <p className={styles.noBoardSubMessage}>
            <FormattedMessage {...messages.ADD_A_BOARD_TO_GET_STARTED} />
          </p>
          <Button
            className={styles.primaryBtn}
            variant="contained"
            color="primary"
            onClick={() => dispatch(createBoard(intl, messages))}
          >
            <FormattedMessage {...messages.ADD_A_BOARD} />
          </Button>
        </div>
      </div>
    </div>
  );
}

export default injectIntl(NoBoard);
